import { useMatomo } from "@jonkoops/matomo-tracker-react";
import { cookiePreference } from "core/cookie";

type TrackEventFn = (
  category: string,
  action: string,
  name?: string,
  value?: number
) => void;

export function useTrackEvent(): TrackEventFn {
  const { trackEvent } = useMatomo();

  const trackUserEvent = (
    category: string,
    action: string,
    name?: string,
    value?: number
  ): void | undefined => {
    if (cookiePreference("analytics")) {
      trackEvent({ category, action, name, value });
    }
  };

  return trackUserEvent;
}
